import type { LucideProps } from "@/components/icons"

import { Loader2 } from "@/components/icons"
import { cn } from "@/lib/utils"

export type SpinnerProps = LucideProps

export function Spinner({ className, ...props }: SpinnerProps) {
  return <Loader2 className={cn("size-5 animate-spin", className)} {...props} />
}
